// Small sync-state machine shared across the app.
export const SYNC = {
  ONLINE: "ONLINE",
  OFFLINE: "OFFLINE",
  SYNCING: "SYNCING",
  SYNC_ERROR: "SYNC_ERROR",
  SYNCED: "SYNCED",
};

let state = {
  status: (typeof navigator !== "undefined" && navigator.onLine) ? SYNC.ONLINE : SYNC.OFFLINE,
  pending: 0,
  error: null,
  lastSync: null,
};
const listeners = new Set();

export function getSyncState() {
  return state;
}

export function setSyncState(patch) {
  state = { ...state, ...patch };
  listeners.forEach((l) => { try { l(state); } catch (_) {} });
  try { window.dispatchEvent(new CustomEvent("sync-state", { detail: state })); } catch (_) {}
}

export function subscribeSync(cb) {
  listeners.add(cb);
  try { cb(state); } catch (_) {}
  return () => listeners.delete(cb);
}
